export const getUserType = (userType: USER_TYPE): string => {
  switch (userType) {
    case "INSTRUCTOR":
      return "Instructor";
    case "SUPER_ADMIN":
      return "Admin";
    case "OWNER":
      return "Owner";
  }
};
